import {ViewBreakpoints} from '@/constants/view-breakpoints';
import debounce from 'lodash/debounce';

const ActionTypes = Object.freeze({
  IS_RESIZING: 'isResizing',
});

const MutationTypes = Object.freeze({
  SET_RESIZE_EVENT: 'setResizeEvent',
});

const viewSizeStore = {
  namespaced: true,
  state: {
    viewBreakpoint: '',
    isResizeEvent: false,
  },

  getters: {
    /**
     * Check whether the given breakpoint is current or not. Accepts either a single value or an array.
     * viewBreakpointIs('small') or viewBreakpointIs(['small', 'medium']).
     * @param breakpoint
     * @return {*}
     */
    viewBreakpointIs: (state) => (breakpoint) => {
      return !Array.isArray(breakpoint)
        ? breakpoint === state.viewBreakpoint
        : breakpoint.includes(state.viewBreakpoint);
    },
    /**
     * Check whether the current breakpoint is less than given breakpoint.
     * @param breakpoint
     * @return {boolean}
     */
    viewBreakpointLessThan: (state) => (breakpoint) => {
      const breakpoints = Object.keys(ViewBreakpoints);
      return breakpoints.indexOf(breakpoint) > breakpoints.indexOf(state.viewBreakpoint);
    },
    /**
     * Check whether the current breakpoint is more than given breakpoint.
     * @param breakpoint
     * @return {boolean}
     */
    viewBreakpointMoreThan: (state) => (breakpoint) => {
      const breakpoints = Object.keys(ViewBreakpoints);
      return breakpoints.indexOf(breakpoint) < breakpoints.indexOf(state.viewBreakpoint);
    },
  },

  mutations: {
    setViewBreakpoint(state, value) {
      state.viewBreakpoint = value;
    },
    [MutationTypes.SET_RESIZE_EVENT](state, payload) {
      state.isResizeEvent = payload;
    },
  },

  actions: {
    handleResize: debounce(
      function ({dispatch}) {
        dispatch('getCurrentBreakpoint');
        dispatch('isResizing');
      },
      50,
      {leading: true}
    ),

    getCurrentBreakpoint({commit}) {
      let breakpoint = '';
      for (let b in ViewBreakpoints) {
        const mediaQuery = window.matchMedia(`(min-width: ${ViewBreakpoints[b]}px)`);
        if (mediaQuery.matches) {
          breakpoint = b;
        } else {
          break;
        }
      }
      commit('setViewBreakpoint', breakpoint);
    },
    [ActionTypes.IS_RESIZING]({commit}) {
      commit('setResizeEvent', true);
      setTimeout(() => {
        commit('setResizeEvent', false);
      }, 2000);
    },
  },
};
export default viewSizeStore;
